import React, { useMemo } from "react";
import fp from "lodash/fp";
import * as yup from "yup";
import SearchQueryParams from "./SearchQueryParams";
import { SearchQueryParamsConsumer } from "./SearchQueryParamsContext";
import useDefaultListLimit from "@hooks/useDefaultListLimit";

const withSearchQueryParamsContext = (options) => {
    return (WrappedComponent) => {
        const WithComponent = (props) => {
            const defaultLimit = useDefaultListLimit({ viewInfoKey: fp.get("viewInfoKey", options) });

            const addedSchema = useMemo(
                () => ({
                    ...fp.get("addedSchema", options),
                    limit: yup.number().positive().max(200).default(defaultLimit),
                }),
                [defaultLimit],
            );

            return (
                <SearchQueryParams addedSchema={addedSchema} removeExtraParams={fp.get("removeExtraParams", options)}>
                    {options.setProps ? (
                        <SearchQueryParamsConsumer>
                            {(values) => <WrappedComponent {...props} searchQueryParams={values} />}
                        </SearchQueryParamsConsumer>
                    ) : (
                        <WrappedComponent {...props} />
                    )}
                </SearchQueryParams>
            );
        };

        return WithComponent;
    };
};

export default withSearchQueryParamsContext;
